export enum RouteName {
  CHARACTERS = 'Characters',
  FAVORITES = 'Favorites',
  CHARACTER = 'Character',
  HOME = 'Home',
  NOT_FOUND = 'NotFound',
}
